import { REDIRECT_PARAM } from '../constants/urls';
import { usePagesContext } from '../context/PagesProvider';

export enum Route {
  LOGIN = '/login',
  NEOLOGIN = '/neologin',
  CREATE = '/create',
  CREATE_SCHOOL = '/create-school',
  PLANS = '/plans',
  AUTH_MIGRATE = '/auth-migrate',
}

/**
 * Custom hook to add extra sugar to specific routes.
 */
export default function useRouterPush() {
  const { query, push: _push } = usePagesContext();

  const push = (route: Route) => {
    const redirect = query[REDIRECT_PARAM] || '';
    let url = route.toString();

    switch (route) {
      case Route.LOGIN:
      case Route.NEOLOGIN:
      case Route.CREATE:
      case Route.CREATE_SCHOOL:
      case Route.PLANS:
        // Persist redirect param
        if (redirect) {
          // Normalize query: Convert array values to strings (take first value if it's an array)
          const searchParams = new URLSearchParams();
          Object.entries(query).forEach(([key, value]) => {
            if (Array.isArray(value)) {
              searchParams.append(key, value[0]); // Use the first value if it's an array
            } else if (value !== undefined) {
              searchParams.append(key, value);
            }
          });

          // Ensure REDIRECT_PARAM is explicitly set
          searchParams.set(
            REDIRECT_PARAM,
            Array.isArray(redirect) ? redirect[0] : redirect,
          );

          url = `${route}?${searchParams.toString()}`;
        }

        _push(url);
        break;
    }
  };

  return push;
}
